<template>
  <div>

    <body>
      <div class="responsive"></div>
      <!--[if lte IE 9]>
      <p class="browserupgrade">
        You are using an <strong>outdated</strong> browser. Please upgrade your browser</a> to improve
        your experience and security.
      </p>
    <![endif]-->

      <!-- ======== preloader start ======== -->

      <!-- <div class="preloader">
      <div class="loader">
        <div class="spinner">
          <div class="spinner-container">
            <div class="spinner-rotator">
              <div class="spinner-left">
                <div class="spinner-circle"></div>
              </div>
              <div class="spinner-right">
                <div class="spinner-circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
      <!-- preloader end -->

      <!-- ======== header start ======== -->
      <header class="header">
        <div class="navbar-area">
          <div class="container" >
            <div class="row align-items-center">
              <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg">
                  <router-link class="navbar-brand" :to="{ name: 'homepage' }">
                    <BrandSignature
                      :src="require('@/homepage-assets/images/logo/logo.svg')"
                      logo-width="180px"
                      size="small"
                      theme="light"
                    />
                  </router-link>

                  <button class="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                  </button>

                  <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                    <ul id="nav" class="navbar-nav">
                      <li class="nav-item">
                        <a class="page-scroll" href="javascript:void(0)" @click="handleScroll('home')">{{
                          $t('messages.login') }}</a>
                      </li>
                      <li class="nav-item">
                        <a class="page-scroll" href="javascript:void(0)" @click="handleScroll('features')">{{
                          $t('homepage.whats') }}?</a>
                      </li>
                      <li class="nav-item">
                        <a class="page-scroll" href="javascript:void(0)" @click="handleScroll('about')">{{
                          $t('homepage.What_Can_I_Do') }}?</a>
                      </li>
                      <li class="nav-item">
                        <a class="page-scroll" href="javascript:void(0)" @click="handleScroll('properties')">{{
                          $t('general.features') }}</a>
                      </li>
                      <li class="nav-item">
                        <a class="page-scroll" href="javascript:void(0)" @click="handleScroll('contact')">{{
                          $t('homepage.contact') }}</a>
                      </li>
                    </ul>
                  </div>

                  <!-- Language Component -->
                  <LanguageSelector />
                  <!-- navbar collapse -->

                  <!-- <a href="#" class="main-btn border-btn btn-hover d-none d-sm-block"><i class="lni lni-calendar"></i> Bir
                    Demo Planlayın</a> -->
                  <!-- <a style="border:2px solid #fff !important; font-weight:600;" href="/#/login"
                    class="main-btn border-btn btn-hover d-none d-sm-block"><i class="lni lni-arrow-right-circle"></i>
                    Giriş Yap</a> -->

                  <!-- <div id="lang-menu">
                    <div><span>TR</span></div>
                    <ul>
                        <li><span>TR</span><img src="assets/images/languages/tr.png" alt=""></li>
                        <li><span>EN</span><img src="assets/images/languages/en.png" alt=""></li>
                        <li><span>AZ</span><img src="assets/images/languages/az.png" alt=""></li>
                        <li><span>KZ</span><img src="assets/images/languages/kz.png" alt=""></li>
                        <li><span>RU</span><img src="assets/images/languages/ru.png" alt=""></li>
                        <li><span>GE</span><img src="assets/images/languages/ge.png" alt=""></li>
                        <li><span>RO</span><img src="assets/images/languages/ro.png" alt=""></li>
                    </ul>
                    </div> -->
                </nav>
                <!-- navbar -->
              </div>
            </div>
            <!-- row -->
          </div>
          <!-- container -->
        </div>
        <!-- navbar area -->
      </header>
      <!-- ======== header end ======== -->

      <!-- Video Modal -->
      <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
              </button>
              <!-- 16:9 aspect ratio -->
              <div class="ratio ratio-16x9">
                <iframe class="embed-responsive-item" src="" id="video" allowscriptaccess="always"
                  allow="autoplay"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ======== hero-section start ======== -->
      <section id="home" class="hero-section">
        <div class="container" style="max-width:100%!important">
          <div class="row align-items-center position-relative">
            <div class="col-lg-6 offset-lg-3">
              <div class="hero-content">
                <BrandSignature
                  :src="require('@/homepage-assets/images/logo/logo.svg')"
                  class="softinya-logo"
                  logo-width="300px"
                  size="large"
                  theme="light"
                />
                <p class="wow fadeInUp mt-2" data-wow-delay=".4s">
                  {{ $t('general.company_platform') }} </p>
                <!-- <a href="javascript:void(0)" class="main-btn btn-white btn-hover wow fadeInUp" data-wow-delay=".6s"><i
                    class="lni lni-calendar"></i> Bir Demo Planlayın</a> -->
                <a style="border:2px solid #fff !important;" href="#properties"
                  class="main-btn border-btn btn-hover wow fadeInUp" data-wow-delay=".6s">{{
                    $t('homepage.explore_features') }}</a>
              </div>
              <div class="hero-img wow fadeInUp" data-wow-delay=".5s">
                <a v-if="!showVideoModal" class="video-btn" @click="openVideo">
                  <img class="img-fluid" :src="require('@/homepage-assets/images/icon-video.png')" alt="">
                  <span class="circle1"></span>
                </a>

                <!-- Video Modal -->
                <div v-if="showVideoModal" class="video-modal-overlay" @click.self="closeVideo">
                  <div class="video-modal-content">
                    <button class="btn-close" @click="closeVideo"></button>
                    <video ref="heroVideo" controls autoplay playsinline disablepictureinpicture controlsList="nodownload noplaybackrate">
                      <source :src="videoSrc" type="video/mp4"/>
                      Tarayıcınız video etiketini desteklemiyor.
                    </video>
                  </div>
                </div>

                <img class="img-fluid" :class="{ 'is-hidden': showVideoModal }" src="@/homepage-assets/images/hero/softinya-teaser.png" alt="Softinya LMS"/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- ======== hero-section end ======== -->

      <!-- ======== feature-section start ======== -->
      <section id="features" class="feature-section pt-50">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <h2 class="section-title text-center d-flex align-items-center justify-content-center">
                <img src="@/homepage-assets/images/logo/logo-2.svg" class="softinya-logo" alt="Softinya LMS"> <span
                  class="logo-tag" style="margin-top:-7px;">{{ $t('general.softinya_with') }};</span>
              </h2>
            </div>
            <div class="col-lg-3 col-md-8 col-sm-10">
              <div class="single-feature">
                <div class="icon-soft wow fadeInUp" data-wow-delay=".3s">
                  <img src="@/homepage-assets/images/icon-card-1.webp" alt="">
                </div>
                <div class="content">
                  <p>
                    {{
                      $t('homepage.you_can_manage') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-8 col-sm-10">
              <div class="single-feature">
                <div class="icon-soft wow fadeInUp" data-wow-delay=".4s">
                  <img src="@/homepage-assets/images/icon-card-2.webp" alt="">
                </div>
                <div class="content">
                  <p>
                    <!-- <b>Oryantasyon</b> süreçlerinizi dijitalde hazırlayabilirsiniz. -->
                    {{
                      $t('homepage.orientation_processes') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-8 col-sm-10">
              <div class="single-feature">
                <div class="icon-soft wow fadeInUp" data-wow-delay=".5s">
                  <img src="@/homepage-assets/images/icon-card-3.webp" alt="">
                </div>
                <div class="content">
                  <p>
                    <!-- <b>Zorunlu eğitimlerinizi</b> kolay bir şekilde çalışanlarınıza atayabilir, raporlayabilir ve
                    sertifikalandırabilirsiniz. -->
                    {{
                      $t('homepage.you_can_easily_assign') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-8 col-sm-10">
              <div class="single-feature">
                <div class="icon-soft wow fadeInUp" data-wow-delay=".6s">
                  <img src="@/homepage-assets/images/icon-card-4.webp" alt="">
                </div>
                <div class="content">
                  <p>
                    <!-- <b>Dijital eğitimlerinizi</b> kendiniz hazırlayıp sisteme yükleyebilir ve çalışanlarınıza
                    atayabilirsiniz. -->
                    {{
                      $t('homepage.digital_trainings') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- ======== feature-section end ======== -->

      <!-- ======== about-section start ======== -->
      <section id="about" class="about-section pt-0">
        <div class="container">
          <div class="row">
            <div class="col-md-6 offset-md-3 text-center pt-100">
              <div class="d-flex align-items-center justify-content-center"><img
                  src="@/homepage-assets/images/logo/logo-2.svg" class="softinya-logo" alt="Softinya LMS">
                <span class="logo-tag">{{ $t('general.with') }}</span>
              </div>
              <div class="section-title">
                <h1 class="color-primary">{{ $t('general.with_softinya') }}</h1>
              </div>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6">
              <div class="about-img">
                <img src="@/homepage-assets/images/switch-softinya.png" alt="" class="w-100 wow fadeInRight"
                  data-wow-duration=".75s" data-wow-delay=".5s" />
                <img src="@/homepage-assets/images/about-left-shape.png" alt="" class="shape shape-1" />

              </div>
            </div>
            <div class="col-xl-6 col-lg-6">
              <div class="about-content">
                <div class="section-title mb-30">
                  <h2 class="mb-25 wow fadeInUp" data-wow-delay=".2s">
                    {{ this.$t('general.oriantation') }}
                  </h2>
                </div>
                <p class="wow fadeInUp mb-25 lead" data-wow-delay=".4s">
                  <span>{{ $t('general.following_challenges') }}</span>
                </p>
                <ul class="wow fadeInUp" data-wow-delay=".4s">
                  <li>{{ this.$t('general.same_topic') }}
                  </li>
                  <li>{{ $t('general.plan_the_time') }}
                  </li>
                  <li>{{ $t('general.planing_the_shifts') }}
                  </li>
                  <li>{{ this.$t('general.process_in_excel') }}
                  </li>
                </ul>

              </div>
            </div>
            <div class="col-md-8 offset-md-2 text-center">
              <p class="lead mb-25 color-primary">{{ $t('general.for_free') }}</p>
              <a style="border:2px solid #7971ff !important;" href="#contact"
                class="main-btn btn-hover border-btn wow fadeInUp" data-wow-delay=".6s">{{ this.$t('general.try_now')
                }}</a>
            </div>
          </div>
        </div>
      </section>
      <!-- ======== about-section end ======== -->

      <!-- ======== about2-section start ======== -->
      <section id="about2" class="about-section pt-50">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6">
              <div class="about-content">
                <div class="section-title mb-30">
                  <h2 class="mb-25 wow fadeInUp" data-wow-delay=".2s">
                    {{ this.$t('general.move_your_legal') }}
                  </h2>
                  <p class="wow fadeInUp" data-wow-delay=".4s">
                    {{ this.$t('general.legal_way') }}
                  </p>
                </div>
                <a style="border:2px solid #7971ff !important;" href="https://katalog.anzera.com.tr/" target="_blank"
                  class="main-btn btn-hover border-btn d-block wow fadeInUp" data-wow-delay=".6s"><i
                    class="lni lni-book"></i>{{ this.$t('general.review_legal') }}</a>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 order-first order-lg-last">
              <div class="about-img-2">
                <img src="@/homepage-assets/images/woman-holding-softinya-logo.png" alt="" class="w-100 wow fadeInLeft"
                  data-wow-duration=".75s" data-wow-delay=".5s" />
                <img src="@/homepage-assets/images/about-right-shape.png" class="shape shape-1" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- ======== about2-section end ======== -->

      <!-- ======== cta-section start ======== -->
      <section class="cta-section ">
        <div class="cta-wrapper ">
          <div class="container ">
            <div class="row ">
              <div class="col-md-7 offset-md-3 text-center ">
                <p class="lead mb-25 ">{{ $t('general.us_to_learn') }}</p>
                <a style="border:2px solid #fff !important;" href="#contact"
                  class="main-btn btn-hover border-btn wow fadeInUp " data-wow-delay=".3s"><i
                    class="lni lni-envelope"></i> {{
                      $t('homepage.get_in_touch') }}</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- ======== cta-section end ======== -->

      <!-- ======== feature-section start ======== -->
      <section id="why" class="feature-extended-section pt-0 ">
        <div class="feature-extended-wrapper ">
          <div class="container">
            <div class="row ">
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".3s">
                    <img src="@/homepage-assets/images/softinya-1.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{ this.$t('general.upload_now') }}</h3>
                    <p>
                      {{ $t('general.resources_you_produce') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-2.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{ this.$t('general.the_certificate') }}</h3>
                    <p>
                      {{ $t('general.your_certificates') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-3.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{ $t('general.make_reports') }}</h3>
                    <p>
                      {{ this.$t('general.flexible_reports') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-4.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{ this.$t('general.class_trainings') }}</h3>
                    <p>
                      {{ $t('general.operational_burdens') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-5.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{ this.$t('general.save_time') }}</h3>
                    <p>
                      {{ $t('general.operational_loads') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-6.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3> {{ $t('general.mobile') }}</h3>
                    <p>
                      {{ this.$t('general.mobile_app') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 wow fadeInUp " data-wow-delay=".5s">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-7.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{ $t('general.blue_grey') }}</h3>
                    <p>
                      {{ this.$t('general.blue_or') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-8.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{
                      $t('homepage.create_blended') }}</h3>
                    <p>
                      {{
                        $t('homepage.ready_catalog_trainings') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <!-- <img src="@/homepage-assets/images/softinya-9.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin"> -->
                    <img
                      :src="activeLanguage === 'tr'
                        ? require('@/homepage-assets/images/softinya-9.png')
                        : require('@/homepage-assets/images/softinya-9-lang.png')"
                      class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin"
                    />
                  </div>
                  <div class="content">
                    <h3> {{
                      $t('homepage.ready_catalog_trainings') }}</h3>
                    <p>
                      {{
                        $t('homepage.with_our_digital_training_catalogue') }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ">
                <div class="single-feature-extended ">
                  <div class="icon-soft wow fadeInUp " data-wow-delay=".5s">
                    <img src="@/homepage-assets/images/softinya-10.png" class="img-fluid"
                      alt="Kendi Eğitimlerinizi Yükleyin">
                  </div>
                  <div class="content ">
                    <h3>{{ this.$t('general.train_your_custemers') }}</h3>
                    <p>
                      {{ $t('general.their_training') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- ======== feature-section end ======== -->

      <!-- ======== properties-section start ======== -->
      <section id="properties" class="properties-section pt-120 ">
        <div class="properties-wrapper container">
          <div class="row">
            <div class="col-md-6 offset-md-3 text-center pb-25">
              <div class="d-flex align-items-center justify-content-center"><img
                  src="@/homepage-assets/images/logo/logo-2.svg" class="softinya-logo" alt="Softinya LMS">
                <!-- <span class="logo-tag">'{{ this.$t('general.softinya_in') }}</span> -->
              </div>
              <div class="section-title">
                <h1 class="color-primary">{{ this.$t('general.softinya_features') }}</h1>
              </div>
            </div>
          </div>

          <template>
            <div class="row">

              <!-- Tab Butonları -->
              <div class="nav-pills col-md-4 col-12" id="v-pills-tab" role="tablist"
                aria-orientation="vertical">
                <button v-for="tab in tabs" :key="tab.id" class="nav-link mb-3 tab-button"
                  :class="{ active: isActive(tab.id) }" @click="setActiveTab(tab.id)">
                  {{ tab.title }}
                </button>
              </div>

              <!-- Tab İçerikleri -->
              <div class="tab-content col-md-8 col-12 wow fadeInLeft" data-wow-delay=".5s" id="v-pills-tabContent">
                <div v-for="tab in tabs" :key="tab.id" class="tab-pane fade" :id="tab.id" role="tabpanel"
                  :aria-labelledby="tab.id + '-tab'" :class="{ show: isActive(tab.id), active: isActive(tab.id) }">
                  <div class="single-feature-extended tab-content-box">
                    <div class="icon-soft wow fadeInUp" data-wow-delay=".5s">
                      <img :src="require(`@/homepage-assets/images/${tab.img}`)" :alt="tab.alt" class="img-fluid">
                    </div>
                    <div class="content">
                      <h3>{{ tab.title }}</h3>
                      <p v-html="tab.content"></p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </template>
        </div>
      </section>
      <!-- ======== properties-section end ======== -->
      <section id="contact" class="properties-section pt-120 ">
        <div class="container">
          <div class="contact__wrapper shadow-lg mt-n9">
            <div class="row no-gutters">
              <div class="col-lg-5 contact-info__wrapper p-5 order-lg-2">
                <h3 class="color--white mb-5">{{
                  $t('homepage.reach_out_to_us') }}</h3>

                <ul class="contact-info__list list-style--none position-relative z-index-101">
                  <li class="mb-4 pl-4">
                    <span class="position-absolute"><i class="fas fa-envelope"></i></span>
                    info@softinya.com
                  </li>
                  <li class="mb-4 pl-4" v-if="activeLanguage === 'tr'">
                    <span class="position-absolute"><i class="fas fa-phone"></i></span>
                    (0212) 267 53 73
                  </li>
                  <li class="mb-4 pl-4" v-if="activeLanguage === 'tr'">
                    <span class="position-absolute"><i class="fab fa-whatsapp"></i></span>
                    (0534) 522 08 71
                  </li>
                  <li class="mb-4 pl-4">
                    <span class="position-absolute"><i class="fas fa-map-marker-alt"></i></span> Esentepe
                    Mah. Büyükdere Cd.
                    <br> Müselles Sk. Onur İş Merkezi
                    <br> No:1/1 K:6 Şişli - İstanbul
                  </li>
                </ul>

              </div>

              <div class="col-lg-7 contact-form__wrapper p-5 order-lg-1">
                <form class="contact-form form-validate" novalidate="novalidate" @submit.prevent="submitContactForm">
                  <div v-if="contactSuccess" class="alert alert-success" role="alert">
                    {{ contactSuccess }}
                  </div>
                  <div v-if="contactError" class="alert alert-danger" role="alert">
                    {{ contactError }}
                  </div>
                  <div class="row">
                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label class="required-field" for="firstName">{{
                          $t('homepage.name') }}</label>
                        <input v-model="contactForm.firstName" type="text" class="form-control" id="firstName" name="firstName" placeholder="">
                      </div>
                    </div>

                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label for="lastName">{{
                          $t('homepage.surname') }}</label>
                        <input v-model="contactForm.lastName" type="text" class="form-control" id="lastName" name="lastName" placeholder="">
                      </div>
                    </div>

                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label class="required-field" for="email">{{
                          $t('homepage.email') }}</label>
                        <input v-model="contactForm.email" type="email" class="form-control" id="email" name="email" placeholder="">
                      </div>
                    </div>

                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label for="phone">{{
                          $t('homepage.tel') }}</label>
                        <input v-model="contactForm.phone" type="tel" class="form-control" id="phone" name="phone" placeholder="">
                      </div>
                    </div>

                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label class="required-field" for="email">{{
                          $t('homepage.company') }}</label>
                        <input v-model="contactForm.company" type="text" class="form-control" id="company" name="company" placeholder="">
                      </div>
                    </div>

                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label class="required-field" for="email">{{
                          $t('homepage.rol') }}</label>
                        <input v-model="contactForm.role" type="text" class="form-control" id="role" name="role" placeholder="">
                      </div>
                    </div>

                    <div class="col-sm-12 mb-3">
                      <div class="form-group">
                        <label class="required-field" for="message">{{
                          $t('homepage.desc') }}</label>
                        <textarea v-model="contactForm.message" class="form-control" id="message" name="message" rows="4" placeholder=""></textarea>
                      </div>
                    </div>

                    <div class="col-sm-12 mb-3">
                      <button type="submit" name="submit" class="btn main-btn" :disabled="isSubmittingContact">
                        <span v-if="isSubmittingContact" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {{ $t('homepage.send') }}</button>
                    </div>

                  </div>
                </form>
              </div>
              <!-- End Contact Form Wrapper -->

            </div>
          </div>
        </div>
      </section>
      <!-- ======== footer start ======== -->
      <footer class="footer ">
        <div class="container ">
          <div class="widget-wrapper ">
            <div class="row ">
              <div class="col-xl-4 col-lg-4 col-md-6 ">
                <div class="footer-widget ">
                  <div class="logo mb-30 ">
                    <router-link class="navbar-brand" :to="{ name: 'homepage' }">
                      <BrandSignature
                        :src="require('@/homepage-assets/images/logo/logo.svg')"
                        logo-width="180px"
                        theme="light"
                      />
                    </router-link>
                  </div>
                  <p class="desc mb-30 text-white ">
                    <a href="mailto:info@softinya.com"><i class="lni lni-envelope"></i> info@softinya.com</a>
                    <a href="tel:0(212)-267-53-73" v-if="activeLanguage === 'tr'"><i class="lni lni-phone"></i> (0212) 267
                      53 73</a>
                    <a href="tel:0(534)-522-08-59" v-if="activeLanguage === 'tr'"><i class="lni lni-whatsapp"></i> (0534)
                      522 08 71</a>
                  </p>
                </div>
              </div>

              <div class="col-xl-2 col-lg-2 col-md-6 ">
                <div class="footer-widget mt-25">
                  <ul class="links ">
                    <li><a href="#home">{{ this.$t('messages.login') }}</a></li>
                    <li><a href="#features">{{
                      $t('homepage.whats') }}?</a></li>
                    <li><a href="#about">{{
                      $t('homepage.What_Can_I_Do') }}?</a></li>
                  </ul>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-6 ">
                <div class="footer-widget mt-25">
                  <ul class="links ">
                    <li><a href="#properties">{{
                      $t('homepage.features') }}</a></li>
                    <li><a href="#contact">{{
                      $t('homepage.contact') }}</a></li>
                    <li>
                      <router-link :to="{ name: 'policies' }">
                        {{ $t('homepage.agreements') }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-6 ">
                <div class="footer-widget ">
                  <ul class="socials">
                    <li>
                      <a target="_blank" href="https://www.instagram.com/anzeraofficial">
                        <i class="uil uil-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a target="_blank" href="https://www.linkedin.com/company/anzeraogrenmeteknolojileri">
                        <i class="uil uil-linkedin"></i>
                      </a>
                    </li>
                    <!-- <li>
                      <a target="_blank" href="https://wa.me/905495783709?text=Hi">
                        <i class="uil uil-whatsapp"></i>
                      </a>
                    </li> -->
                  </ul>

                </div>
              </div>

            </div>
          </div>
        </div>
      </footer>
      <!-- ======== footer end ======== -->

      <!-- ======== scroll-top ======== -->
      <a href class="scroll-top btn-hover" @click.prevent="handleScroll('home')">
        <i class="fas fa-chevron-up "></i>
      </a>

      <a v-if="activeLanguage !== 'tr'" class="whatsapp-btn"
      href="https://wa.me/905495783709?text=Hi"
      target="_blank"
      rel="noopener"
      aria-label="WhatsApp">
      <i class="fab fa-whatsapp"></i>
      </a>
    </body>
  </div>
</template>
<script>
import i18nService from "@/core/services/i18n.service.js";
import LanguageSelector from "@/view/components/LanguageSelector.vue";
import BrandSignature from "@/view/layouts/shared/components/BrandSignature.vue";
import axios from "axios";

export default {
  name: "homepage",
  components: {
    BrandSignature,
    LanguageSelector,
  },
  data() {
    return {
      showVideoModal: false,
      videos: {
        tr: require('@/homepage-assets/images/softinyalms-tr.mp4'),
        en: require('@/homepage-assets/images/softinyalms-en.mp4'),
        az: require('@/homepage-assets/images/softinyalms-az.mp4'),
        de: require('@/homepage-assets/images/softinyalms-de.mp4'),
      },
      activeTab: 'v-pills-kullanici-entegrasyonlari',
      contactForm: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        role: "",
        message: "",
        recaptchaToken: "",
      },
      recaptchaSiteKey: "",
      recaptchaLoadError: false,

      isSubmittingContact: false,
      contactSuccess: "",
      contactError: "",
    }
  },
  computed: {
    activeLanguage: {
      get() {
        return this.$i18n.locale;
      },
      set(val) {
        this.$i18n.locale = val;
        i18nService.setActiveLanguage(val);
        localStorage.setItem('activeLanguage', val);
      }
    },
    userInfo: {
      get: function () {
        return JSON.parse(this.secureLocalStorage('user'));
      },
      set: function () { },
    },

    videoSrc() {
      let lang = (this.activeLanguage || 'en');
      return this.videos[lang] || this.videos.en;
    },
    tabs() {
        return [
          {
            id: 'v-pills-kullanici-entegrasyonlari',
            title: this.$t('general.user_integrations'),
            img: 'softinya-prop-1.webp',
            alt: 'Sofitanya LMS ile Kullanıcı Entegrasyonları',
            content: this.$t('general.are_registered')
          },
          {
            id: 'v-pills-icerik-olusturma',
            title: this.$t('general.creating_content'),
            img: 'softinya-prop-2.webp',
            alt: 'Sofitanya LMS ile İçerik Oluşturma',
            content: this.$t('general.content_description')
          },
          {
            id: 'v-pills-otomasyon',
            title: this.$t('general.automation'),
            img: 'softinya-prop-3.webp',
            alt: 'Sofitanya LMS ile Otomasyon',
            content: this.$t('general.automation_description')
          },
          {
            id: 'v-pills-oyunlastirma',
            title: this.$t('general.for_gamification'),
            img: 'softinya-prop-4.webp',
            alt: 'Sofitanya LMS ile Oyunlaştırma',
            content: this.$t('general.for_gamification_description')
          },
          {
            id: 'v-pills-anketler',
            title: this.$t('general.for_surveys'),
            img: 'softinya-prop-5.png',
            alt: 'Sofitanya LMS ile Anketler',
            content: this.$t('general.for_surveys_description')
          },
          {
            id: 'v-pills-sinavlar',
            title: this.$t('general.for_exams'),
            img: 'softinya-prop-6.webp',
            alt: 'Sofitanya LMS ile Sınavlar',
            content: this.$t('general.for_exams_description')
          },
          {
            id: 'v-pills-raporlar',
            title: this.$t('general.for_reports'),
            img: 'softinya-prop-7.webp',
            alt: 'Sofitanya LMS ile Raporlar',
            content: this.$t('general.for_reports_description')
          }
        ];
    }
  },

  methods: {
    sanitizeRecaptchaKey(rawKey) {
      return String(rawKey || "").replace(/['"]/g, "").trim();
    },
    initRecaptcha() {
      this.fetchRecaptchaSiteKey();
    },

    async fetchRecaptchaSiteKey() {
      try {
        const backendUrl = process.env.VUE_APP_BACKEND_APP_URL || "";
        const url = `${backendUrl}/api/contact-form/recaptcha-site-key`;

        const response = await axios.get(url);


        const siteKey = this.sanitizeRecaptchaKey(response?.data?.data?.site_key);

        if (siteKey) {
          this.recaptchaSiteKey = siteKey;
          this.recaptchaLoadError = false; // Reset error state
          this.loadRecaptchaScript();
        } else {
          console.error("reCAPTCHA site key bulunamadı, cevap:", response);
          this.recaptchaLoadError = true;
        }
      } catch (error) {
        console.error("reCAPTCHA site key alınamadı, hata:", error);
        console.error("Hata detayı:", error.response?.data || error.message);
        this.recaptchaLoadError = true;
      }
    },

    loadRecaptchaScript() {
      if (!this.recaptchaSiteKey) {
        console.error("loadRecaptchaScript: Site key yok");
        this.recaptchaLoadError = true;
        return;
      }

      const existing = document.getElementById("recaptcha-v3-script");
      if (existing) {
        const existingKey = existing.getAttribute("data-key");
        if (existingKey === this.recaptchaSiteKey) {
          // Script zaten yüklenmiş, kontrol et
          if (window.grecaptcha) {
            this.recaptchaLoadError = false;
          }
          return;
        }
        existing.remove();
      }

      this.recaptchaLoadError = false;

      const script = document.createElement("script");
      script.id = "recaptcha-v3-script";
      script.setAttribute("data-key", this.recaptchaSiteKey);
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(this.recaptchaSiteKey)}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        // Script yüklendi, şimdi grecaptcha hazır olana kadar bekle
        const checkGrecaptcha = setInterval(() => {
          if (window.grecaptcha) {
            clearInterval(checkGrecaptcha);
            this.recaptchaLoadError = false;
          }
        }, 100);

        // 5 saniye sonra kontrolü bitir
        setTimeout(() => {
          clearInterval(checkGrecaptcha);
          if (!window.grecaptcha) {
            console.error("grecaptcha 5 saniye içinde hazır olmadı");
            this.recaptchaLoadError = true;
          }
        }, 5000);
      };

      script.onerror = (e) => {
        console.error("reCAPTCHA script yüklenirken hata:", e);
        this.recaptchaLoadError = true;
      };

      document.head.appendChild(script);
    },

    async getRecaptchaToken() {
      if (this.recaptchaLoadError) {
        throw new Error("reCAPTCHA script yüklenemedi. Lütfen sayfayı yenileyin.");
      }

      if (!this.recaptchaSiteKey) {
        throw new Error("reCAPTCHA site key bulunamadı.");
      }

      if (!window.grecaptcha) {
        throw new Error("reCAPTCHA henüz yüklenmedi. Lütfen biraz bekleyip tekrar deneyin.");
      }

      // grecaptcha.ready() yerine dogrudan execute kullanmak daha guvenilir
      return new Promise((resolve, reject) => {
        try {
          window.grecaptcha.execute(this.recaptchaSiteKey, { action: "contact_form" })
            .then((token) => {
              if (!token || token.length < 10) {
                reject(new Error("Geçersiz reCAPTCHA token"));
              } else {
                resolve(token);
              }
            })
            .catch((err) => {
              console.error("grecaptcha.execute hatası:", err);
              reject(new Error("reCAPTCHA doğrulaması başarısız: " + (err?.message || err)));
            });
        } catch (e) {
          console.error("grecaptcha execute çağrı hatası:", e);
          reject(new Error("reCAPTCHA çalıştırılırken hata oluştu."));
        }
      });
    },

    async submitContactForm() {
      if (this.isSubmittingContact) return;

      // Form validasyonu
      if (!this.contactForm.firstName || !this.contactForm.email ||
          !this.contactForm.company || !this.contactForm.role || !this.contactForm.message) {
        this.contactError = "Lütfen tüm zorunlu alanları doldurun.";
        return;
      }

      this.contactError = "";
      this.contactSuccess = "";
      this.isSubmittingContact = true;

      try {
        // reCAPTCHA token al
        let token = null;
        let retries = 3;
        let lastError = null;

        // grecaptcha yuklenmesini beklemek icin retry mekanizmasi
        while (retries > 0 && !token) {
          try {
            token = await this.getRecaptchaToken();
            if (token) break;
          } catch (e) {
            lastError = e;
            console.error("reCAPTCHA token alınamadı:", e);
            retries--;
            if (retries > 0) {
              await new Promise(r => setTimeout(r, 500));
            }
          }
        }

        if (!token) {
          console.error("reCAPTCHA token alınamadı, son hata:", lastError);
          throw new Error("reCAPTCHA doğrulaması başarısız oldu. Lütfen sayfayı yenileyip tekrar deneyin.");
        }

        this.contactForm.recaptchaToken = token;

        await this.sendContactForm();
      } catch (err) {
        console.error("Form gönderim hatası:", err);
        this.contactError = err?.response?.data?.message || err?.message || "Form gönderilirken bir hata oluştu.";
      } finally {
        this.isSubmittingContact = false;
      }
    },
    async sendContactForm() {
      try {
        const payload = { ...this.contactForm };
        const backendUrl = process.env.VUE_APP_BACKEND_APP_URL || "";
        const url = `${backendUrl}/api/contact-form`;

        const response = await axios.post(url, payload, {
          headers: { "Content-Type": "application/json" },
        });

        this.contactSuccess =
          response?.data?.message || "";

        this.resetContactForm();
      } catch (error) {
        this.contactError =
          error?.response?.data?.message ||
          error?.message ||
          "";
      }
    },

    resetContactForm() {
      this.contactForm = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        role: "",
        message: "",
        recaptchaToken: "",
      };
    },
    openVideo() {
      this.showVideoModal = true;
      this.$nextTick(() => {
        let video = this.$refs.heroVideo;
        if (video) {
          video.currentTime = 0;
          let p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      });
    },
    closeVideo() {
      let video = this.$refs.heroVideo;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      this.showVideoModal = false;
    },
    setActiveTab(tabId) {
      this.activeTab = tabId;
    },
    isActive(tabId) {
      return this.activeTab === tabId;
    },
    handleScroll(target) {
      if (this.$route.name !== "homepage") {
        this.$router.push({ name: "homepage", hash: `#${target}` }).then(() => {
          this.$nextTick(() => {
            const el = document.getElementById(target);
            if (el) el.scrollIntoView({ behavior: "smooth" });
          });
        });
      } else {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    },

    scrollToTarget(target) {
      this.$nextTick(() => {
        const el = document.querySelector(`#${target}`);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    },

    scrollToHash() {
      const hash = this.$route.hash;
      if (hash) {
        const target = hash.replace('#', '');
        this.scrollToTarget(target);
      }
    },
  },
  mounted() {
    this.scrollToHash();
    this.initRecaptcha();

    const supportedLangs = (i18nService.languages || []).map(l => l.lang);

    const fallbackLang = supportedLangs.includes('en') ? 'en' : i18nService.getActiveLanguage();

    let lang = localStorage.getItem("activeLanguage");

    if (!lang) {
      const browserLangRaw =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language || navigator.userLanguage ||"";

      const short = browserLangRaw.split("-")[0].toLowerCase();

      if (short && supportedLangs.includes(short)) {
        lang = short
      } else {
        lang = fallbackLang
      }
    }

    this.activeLanguage = lang;

    let subdomain = window.location.host.split('.')[0]

    if ((subdomain !== 'www' && subdomain !== 'localhost:8080') || window.location.pathname !== '/') {
      // if ((subdomain !== 'www' && subdomain !== 'localhost:8080') || window.location.hash !== '#/homepage') {
      this.$router.push({ path: "/dashboard" })
    }

    // Kayıtlı dili kontrol et ve ayarla
    const storedLanguage = localStorage.getItem("activeLanguage");

    if (storedLanguage) {
      i18nService.setActiveLanguage(storedLanguage);
    }
  },
  watch: {
    // Route değişirse hash varsa scroll et
    "$route"() {
      this.scrollToHash();
    },
  },
};


</script>

<style  src='../../homepage-assets/css/bootstrap.min.css' scoped></style>
<style  src='../../homepage-assets/css/animate.css' scoped></style>
<style  src='../../homepage-assets/css/main.css' scoped></style>
<style  src='../../homepage-assets/css/custom.css' scoped></style>
<style>
.contact__wrapper {
  position: relative;
  z-index: 1;
  /* header’ın altına düşmemesi için */
}

.header {

  z-index: 1;
  /* header her zaman üstte kalacak şekilde */
}

.tab-button {
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: 600;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0.6rem 1rem;
  background-color: #f9f9f9;
  transition: all 0.3s;
  text-align: left;
}

.tab-button:hover {
  background-color: #eee;
}

.tab-button.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

/* İçerik kutusu */
.tab-content-box {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  display: flex;
  gap: 1rem;
}

.tab-content-box .icon-soft img {
  max-width: 100px;
}

.tab-content-box .content h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.tab-content-box .content p {
  font-size: 1rem;
  line-height: 1.5;
}

.tab-button {
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 14px 18px;
  font-weight: bold;
  text-align: left;
  transition: all 0.3s ease;
  color: #333;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.09);
}

.tab-button:not(:last-child) {
  margin-bottom: 10px;
  /* Tablar arası boşluk */
}

.tab-button:hover {
  background-color: #e6e6e6;
  cursor: pointer;
  transform: translateY(-2px);
  /* Hafif yükselme efekti */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.tab-button.active {
  background-color: #007bff;
  /* Aktif tab rengi */
  color: #fff;
  border-color: #007bff;
  box-shadow: 0 6px 15px rgba(0, 123, 255, 0.25);
}

.tab-content-box {
  background-color: #fff;
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.nav-pills {
  background-color: #fff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.nav-link {
  color: #7971ff !important;
}

.nav-link.active {
  background-color: #7971ff !important;
  color: #fff !important;
}

.socials {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  margin-top: 80px;
}

.socials li a {
  text-decoration: none;
  font-size: 32px;
  color: #000;
  transition: transform 0.3s, color 0.3s;
}

.socials li a:hover {
  transform: scale(1.2);
}

.socials li a:hover .uil-instagram {
  color: #E1306C;
}

.socials li a:hover .uil-linkedin {
  color: #0077B5;
}

.socials li a:hover .uil-whatsapp {
  color: #25D366;
}
.whatsapp-btn{
  position: fixed;
  left: 16px;
  bottom: 30px;
  width: 55px; 
  height: 55px;
  border-radius: 50%;
  background: #25D366;
  border: 2px solid #fff;
  display: flex !important; 
  align-items: center; 
  justify-content: center;
  line-height: 0;
  z-index: 10000;
  transition: transform .2s, box-shadow .2s;
}

.whatsapp-btn i{
  font-size: 40px;
  color: #fff !important; 
}

.hero-img{
  position: relative;
}

.hero-img > img.is-hidden {
  opacity: 0;  
  pointer-events: none;   
}

.video-modal-overlay{
  position: absolute;
  inset: 0;
  display: grid;
}

.video-modal-content{
  width: min(100%, 960px);
  aspect-ratio: 16 / 9;  
  overflow: hidden;
}

.video-modal-content video{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.required-field::after {
  content: " *";
  color: red;
  font-weight: bold;
}

</style>

<!-- <link rel="stylesheet" href="@/homepage-assets/css/bootstrap.min.css" />
<link rel="stylesheet" href="@/homepage-assets/css/lineicons.css" />
<link rel="stylesheet" href="@/homepage-assets/css/animate.css" />
<link rel="stylesheet" href="@/homepage-assets/css/main.css" />
    <link rel="stylesheet" href="@/homepage-assets/css/custom.css" /> */ -->

<!-- @import '../../homepage-assets/css/lineicons.css';
@import '../../homepage-assets/css/animate.css';
@import '../../homepage-assets/css/main.css';
@import '../../homepage-assets/css/custom.css'; -->
